import useCustomQuery from '@hooks/useCustomQuery';
import { CoreFactory } from '@bridge/factory/CoreFactory';
import { useSessionStore } from '@stores/session';

const metrics = CoreFactory.getMetrics();
const logger = CoreFactory.getLogger();

export const useTelemetryFlush = () => {
  const flushMetricsAndLogs = async () => {
    /*
     * Read the session state at flush time instead of capturing it in the
     * render closure. The flush is triggered in the same commit in which
     * useLoginResourceQuery stores the directory-level preferences
     * (setSession), so a closure captured on a previous render would still
     * observe isLogUploaderEnabledAtDirectoryLevel as false and skip the
     * log upload even when it is enabled for the directory.
     */
    const { region, isLogUploaderEnabledAtDirectoryLevel, domainProperties } =
      useSessionStore.getState();
    const orgName = domainProperties?.OrganizationName as string;

    if (orgName && region?.endpoint) {
      logger.info('starting telemetry flush');
      if (isLogUploaderEnabledAtDirectoryLevel) {
        logger.startLogUpload(orgName, region.endpoint);
        logger.flush();
      } else {
        logger.info(
          'LogUpload is not enabled for current workspace. Skipping log flush'
        );
      }
      await metrics.flush();
    }
  };

  const result = useCustomQuery(
    ['flush-telemetry'],
    async () => {
      return await flushMetricsAndLogs();
    },
    {
      enabled: false,
    }
  );

  return {
    ...result,
    flushTelemetry: result.refetch,
  };
};
